import { EventDispatcher } from '../../utils/EventDispatcher';

// Refers to the existed blocks

export class AbstractDomComponent extends EventDispatcher {
    #element;
    #hiddenDelay = 1000;
    #rafid;
    _needListeners = false;

    show() {
        if (this.#rafid) cancelAnimationFrame(this.#rafid);

        if (this._needListeners) {
            this._addListeners();
        }

        this._prepareToShow();
        requestAnimationFrame(() => {
            setTimeout(() => { this._show(); }, 200);
        });
    }

    hide(clear, removeFromDom) {
        if (this._needListeners) this._removeListeners();

        this._hide();
        this.#waitForHidden(clear, removeFromDom);
    }

    remove(clear, removeFromDom) {
        this.#remove(clear, removeFromDom);
    }

    #remove(clear, removeFromDom) {
        if (removeFromDom && this._elementsList instanceof Array) {
            this._elementsList.forEach((el) => {
                if (el.parentNode) el.parentNode.removeChild(el);
            });
        } else {
            this._hidden();
        }
        if (clear) this._clear();
    }

    // eslint-disable-next-line class-methods-use-this
    _prepareToShow() {
        // Override this method to make elements ready for display
    }

    // eslint-disable-next-line class-methods-use-this
    _show() {
        // Override this method to show elements if necessary
    }

    // eslint-disable-next-line class-methods-use-this
    _hide() {
        // Override this method to hide elements if necessary
    }

    // eslint-disable-next-line class-methods-use-this
    _hidden() {
        // Override this method to make elements inaccessible
    }

    // eslint-disable-next-line class-methods-use-this
    _clear() {
        // Override this method to remove all the references
    }

    #waitForHidden(clear, removeFromDom) {
        const t = Date.now();
        const checkTime = () => {
            const now = Date.now();

            if (now - t > this.#hiddenDelay) {
                this.#remove(clear, removeFromDom);

                return;
            }

            requestAnimationFrame(checkTime);
        };

        this.#rafid = requestAnimationFrame(checkTime);
    }

    // eslint-disable-next-line class-methods-use-this
    _addListeners() {
        // Override this method to make elements interactive
    }

    // eslint-disable-next-line class-methods-use-this
    _removeListeners() {
        // Override this method to remove all the listeners associated
    }

    // eslint-disable-next-line class-methods-use-this
    get parentNode() {
        return null;
    }

    set hiddenDelay(value) {
        this.#hiddenDelay = value * 1000;
    }

    get hiddenDelay() {
        return this.#hiddenDelay / 1000;
    }

    // eslint-disable-next-line class-methods-use-this
    get _elementsList() {
        return [];
    }

    getSyncBoundingRect() {
        // Overwrite it otherwise
        if (!(this._elementsList instanceof Array) || this._elementsList.length < 1) return null;

        return this._elementsList[0].getBoundingClientRect();
    }
}
